export enum TenantFormFieldNames {
  LastName = "lastName",
  FirstName = "firstName",
  BirthDate = "birthDate",
  Phone = "phone",
  Email = "email",
  Civility = "civility",
  Guarantor = "guarantor",
  ProfessionalSituation = "professionalSituation",
  CheckInDate = "checkInDate",
  CheckOutDate = "checkOutDate",
  RentPaymentsUpToDate = "rentPaymentsUpToDate",
  Incomes = "incomes",
}

export enum IncomesFormFieldNames {
  IncomeType = 'incomeType',
  Amount = 'amount'
}
